<template>

	<v-content>
		<v-container fluid fill-height>
			<v-layout row>


				<div class="Profile">
					<div class="profileTop">
						<div class="avatar">
							<img :src="me.logo" alt="" title="Gravatar dan alınıyor">
						</div>
						<div class="fullname">
							{{me.firstname}} {{me.lastname}} &nbsp;
						</div>
						<div class="email">
							{{me.email}} &nbsp;
						</div>
						<div class="user_group">
							{{me.group.group_name}} &nbsp;
						</div>
						<div class="ftpkernelinstall">
							<a href="http://robotic.ajans360.com/storage/RoboticKernelInstall.exe" target="_blank">FTP Kernel Install</a>
						</div>
					</div>


					<div class="profileForm">
						<div class="formLine">
							<v-text-field name="uuu" v-model="me.username" label="Kullanıcı Adı" readonly>
							</v-text-field>
						</div>
						<div class="formLine">
							<v-text-field name="ppp" v-model="me.password"
								:append-icon="showPassword ? 'visibility' : 'visibility_off'"
								:type="showPassword ? 'text' : 'password'" label="Şifreyi değiştir"
								hint="Boş bırakılırsa değişiklik yapılmaz" @click:append="showPassword = !showPassword"
								autocomplete="false" autocorrect="off" autocapitalize="off" spellcheck="false"
							>
							</v-text-field>
						</div>
						<div class="formLineHr"> </div>
						<div class="formLine">
							<v-text-field v-model="me.firstname" label="Ad" placeholder="Örn: Melih" required>
							</v-text-field>
						</div>
						<div class="formLine">
							<v-text-field v-model="me.lastname" label="Soyad" placeholder="Örn: ÖRNEKBAŞ"
								required>
							</v-text-field>
						</div>
						<div class="formLine">
							<v-text-field v-model="me.email" label="E-Mail"
								placeholder="Örn: melih@ajans360.com" required>
							</v-text-field>
						</div>
						<div class="formLine">
							<v-text-field v-model="me.birthday" label="Doğum Tarihi (dd.mm.yyyy)"
								placeholder="Örn: 01.01.1994" required>
							</v-text-field>
						</div>
						<div class="formLine">
							<div class="text-xs-center">
								<v-btn round outline color="indigo" dark :loading="isSaving" @click="saveMe()">DEĞİŞİKLİĞİ KAYDET</v-btn>
							</div>
							<div class="text-xs-center">
								<v-btn round outline color="error" dark :loading="isExiting" @click="signoutMe()">HESAPTAN ÇIKIŞ YAP</v-btn>
							</div>
						</div>
					</div>

				</div>






			</v-layout>
		</v-container>
	</v-content>


</template>


<script>
	export default {
		name: "ProfileIndex",
		data: () => ({
			me: {},
			showPassword: false,
			isSaving : false,
			isExiting : false
		}),
		mounted() {
			this.me = JSON.parse(JSON.stringify(this.$store.state.signedUser))
			this.me.password = ""
		},
		methods:{
			saveMe(){
				if(!this.isSaving){
					this.isSaving = true
					this.$http.post(process.env.VUE_APP_API_URL + "/profile/save", this.me, {
						params: {}
					}).then(response => { 
						this.isSaving = false
						location.reload();
					})
				}
			},
			signoutMe(){
				if(!this.isExiting){
					this.isExiting = true
					this.$http.post(process.env.VUE_APP_API_URL + "/auth/logout", this.me, {
						params: {}
					}).then(response => { 
						this.isExiting = false
						location.reload();
					})
				}
			}
		}
	}
</script>



<style lang="less">
	.Profile {
		width: 400px;
		max-width: calc(~"100% - 20px");
		margin: 0px auto;
		min-height: 300px;
		background-color: #fff;
		box-shadow: 0 0 5px rgb(141, 141, 141);

		.profileTop {
			border-bottom: 2px solid #ccc;
			padding: 10px 0px;

			.avatar {
				text-align: center;

				img {
					width: 100px;
					height: 100px;
					object-fit: cover;
					border-radius: 50%;
					border: 2px solid rgb(158, 158, 158);
				}
			}

			.fullname {
				text-align: center;
				font-size: 30px;
				font-weight: 300;
			}

			.email {
				text-align: center;
				font-size: 12px;
				color: rgb(100, 100, 100);
			}
			.user_group {
				text-align: center;
				font-size: 12px;
				color: rgb(0, 51, 146);
				font-weight: 600;
			}
			.ftpkernelinstall {
				text-align: center;
				font-size: 10px;
				margin-top:5px;
				a{
					text-decoration: none;
					background-color: rgba(0, 102, 255, 0.582);
					color:#fff;
					padding:3px 12px;
					border-radius: 20px;
				}
			}
		}

		.profileForm {
			padding: 15px;

			.formLineHr {
				border-bottom: 2px solid #ccc;
				margin: 10px -15px 20px -15px;
			}
		}
	}
</style>